class ProductAddOnMultiple extends HTMLElement {
  constructor() {
    super();
    this.addOnSelects = Array.from(this.querySelectorAll('select.add-on-select'));
    this.addOnChanged = false;

    // mark when a user changes any add-on select
    this.addOnSelects.forEach((sel) => {
      sel.addEventListener('change', () => { this.addOnChanged = true; });
    });
  }

  mapProperty(prop) {
    switch (prop) {
      case 'El':
      case 'Ea':
        return 'Măsură verighetă pentru';
      case 'diamant':
        return 'Piatra centrală';
      case 'aur':
        return 'Metal';
      default:
        return prop || 'Opțiune';
    }
  }

  // Returns array of items to /cart/add.js
  getItems() {
    const items = [];
    this.addOnSelects.forEach((sel) => {
      const opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      if (opt.classList.contains('add-on') && opt.dataset.id) {
        const propKey = this.mapProperty(opt.dataset.property);
        const propVal = opt.dataset.property || '';
        items.push({
          id: opt.dataset.id,
          quantity: 1,
          properties: { [propKey]: propVal }
        });
      }
    });
    return items;
  }
}

customElements.define('product-add-on-multiple', ProductAddOnMultiple);
